import request from '@/utils/request'

export function allocRole(id, roles) {
  return request({
    url: `/sysUserRole/allocRole/${id}`,
    method: 'post',
    data: roles
  })
}
